export function convertImperialToMetricLabel(label?: string | null): string {
  if (!label) return ''
  const normalized = label.replace(/\s+/g, ' ').trim()
  const match = normalized.match(/([\d.]+)\s*(?:["in]+)?\s*(?:x|×)\s*([\d.]+)\s*(?:["in]+)?/i)
  if (!match) return ''
  const toCm = (value: string) => {
    const parsed = parseFloat(value)
    if (!Number.isFinite(parsed)) return null
    return Math.round(parsed * 2.54)
  }
  const first = toCm(match[1])
  const second = toCm(match[2])
  if (first == null || second == null) return ''
  return `${first} x ${second} cm`
}
